<template>
  <div class="spinner">
    <div class="spinner-shapes">
      <span class="rect1" />
      <span class="rect2" />
      <span class="rect3" />
      <span class="rect4" />
      <span class="rect5" />
    </div>
    <span v-if="message !== null" class="spinner-message">
      {{ message }}
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-icon  v-if="displayInfos" class="info-icon" small v-on="on">info</v-icon>
        </template>
        <span
          >Si l'opération vous paraît trop longue, veuillez vous reconnecter
          pour réactualiser l'état de l'opération.</span
        >
      </v-tooltip>
    </span>
  </div>
</template>

<script>
export default {
  name: 'Spinner',

  props: {
    message: {
      type: String,
      default: null,
    },
    displayInfos: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_variables';
.spinner {
  cursor: default;
  display: flex;
  height: 30px;
  flex-direction: column;
  text-align: center;
  font-size: 10px;
  .spinner-shapes {
    pointer-events: none;
    > span {
      background-color: $altYellow;
      height: 15px;
      width: 6px;
      display: inline-block;

      -webkit-animation: sk-stretchdelay 1.2s infinite ease-in-out;
      animation: sk-stretchdelay 1.2s infinite ease-in-out;
    }
    .rect2 {
      -webkit-animation-delay: -1.1s;
      animation-delay: -1.1s;
    }
    .rect3 {
      -webkit-animation-delay: -1s;
      animation-delay: -1s;
    }
    .rect4 {
      -webkit-animation-delay: -0.9s;
      animation-delay: -0.9s;
    }
    .rect5 {
      -webkit-animation-delay: -0.8s;
      animation-delay: -0.8s;
    }
  }
  .spinner-message {
    color: $altYellow;
    display: inline-block;
    height: 14px;
    line-height: 14px;
    font-size: 14px;
    text-align: center;

    .info-icon {
      pointer-events: all !important;
    }
  }
}

@-webkit-keyframes sk-stretchdelay {
  0%,
  40%,
  100% {
    -webkit-transform: scaleY(0.35);
    -webkit-transform-origin: bottom;
  }
  20% {
    -webkit-transform: scaleY(1);
    -webkit-transform-origin: bottom;
  }
}

@keyframes sk-stretchdelay {
  0%,
  40%,
  100% {
    transform: scaleY(0.4);
    transform-origin: bottom;
    -webkit-transform: scaleY(0.35);
  }
  20% {
    transform: scaleY(1);
    transform-origin: bottom;
    -webkit-transform: scaleY(1);
  }
}
</style>
